import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// slices
import productReducer from "./slices/Products/productSlice";
import authReducer from "./slices/auth/authSlice";
import signUpReducer from "./slices/signup/signUpSlice";
import forgotPasswordReducer from "./slices/forgotPassword/forgotPasswordSlice";
import resetPasswordReducer from "./slices/resetPassword/resetPasswordSlice";
import changePasswordReducer from "./slices/changePassword/changePasswordSlice";
import categoryReducer from "./slices/category/categorySlice";
import filterReducer from "./slices/filter/filterSlice";
import cartReducer from "./slices/cart/cartSlice";
import cityReducer from "./slices/city/cityReducer";
import userReducer from "./slices/user/userSlice";
import businessLocationReducer from "./slices/businessLocation/businessLocationSlice";
import orderReducer from "./slices/order/orderSlice";
import favoriteReducer from "./slices/favorite/favoriteSlice";
import bannerReducer from "./slices/banner/bannerSlice";
import reviewReducer from "./slices/review/reviewSlice";


// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
};

// const productPersistConfig = {
//   key: 'product',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: ['sortBy', 'checkout']
// };

const rootReducer = combineReducers({
  product: productReducer,
  auth: authReducer,
  signup: signUpReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  changepassword: changePasswordReducer,
  category: categoryReducer,
  filter: filterReducer,
  cart: cartReducer,
  order: orderReducer,
  city:cityReducer,
  user: userReducer,
  businessLocation: businessLocationReducer,
  banner:bannerReducer,
  favorite: favoriteReducer,
  review: reviewReducer,
});

export { rootPersistConfig, rootReducer };
